// extracted by mini-css-extract-plugin
module.exports = {"like-button":"like-button--3Sn378Pn"};